import React, { useState } from 'react'
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'
import { Button } from 'antd'
import toast from "react-hot-toast";

type PaymentCardProps = {
    addCard: (id: string) => Promise<void>
    isLoading: boolean
}

const PaymentCard = ({ addCard, isLoading }: PaymentCardProps) => {
    const [isCardIdLoading, setIsCardIdLoading] = useState(false)
    const stripe = useStripe()
    const elements = useElements()

    const handleSubmit = async (event: any) => {
        try {
            const loader = toast.loading("Progressing...");
            setIsCardIdLoading(true)

            event.preventDefault()

            if (!stripe || !elements) {
                toast.dismiss(loader);
                return
            }

            const cardElement = elements.getElement(CardElement)

            if (cardElement) {
                const result = await stripe.createToken(cardElement)

                if (result.token) {
                    await addCard(result.token.id)
                }
            }

            toast.dismiss(loader);
        } finally {
            setIsCardIdLoading(false)
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <CardElement />

            <Button
                loading={isLoading || isCardIdLoading}
                htmlType="submit"
                style={{ marginTop: 16 }}
                type="primary"
                disabled={!stripe}>
                Submit
            </Button>
        </form>
    )
}

export default PaymentCard
